export default function (qs: string) {
	qs = qs.split('+').join(' ')

	const params: any = {}
	let tokens: RegExpExecArray | null
	const re = /[?&]?([^=]+)=([^&]*)/g

	while ((tokens = re.exec(qs))) {
		if (tokens[1] === '&instructionId') {
			tokens[1] = 'instructionId'
		}

		params[decodeURIComponent(tokens[1]!).toLowerCase()] = decodeURIComponent(
			tokens[2]!,
		)
	}
	return params
}
